import { GetCommentListByPostIdQuery_getCommentListByPostId_comments } from "@bakbak/controller";
import { List, Spin } from 'antd';
import * as React from 'react';
import * as isEqual from "react-fast-compare";
import * as InfiniteScroll from 'react-infinite-scroller';
import { CommentItemConnector } from '../item/CommentItemConnector';


interface Props {
  commentList: GetCommentListByPostIdQuery_getCommentListByPostId_comments[];
  fetchMore: () => void;
  hasMoreComments: boolean;
}

export class CommentListView extends React.Component<Props> {
  state = {
    loading: false,
  }

  shouldComponentUpdate(nextProps: Props) {
    return !(
      isEqual(this.props.commentList, nextProps.commentList)
      && isEqual(this.props.fetchMore, nextProps.fetchMore)
      && isEqual(this.props.hasMoreComments, nextProps.hasMoreComments)
    )
  }

  loadMore = () => {
    if (this.props.hasMoreComments) {
      this.props.fetchMore();
    }
  }
  renderItem = (comment: GetCommentListByPostIdQuery_getCommentListByPostId_comments) => {
    return <CommentItemConnector comment={comment} />;
  }

  render() {
    return (
      <div style={styles.infiniteContainer}>
        <InfiniteScroll
          initialLoad={false}
          pageStart={0}
          loadMore={this.loadMore}
          hasMore={this.props.hasMoreComments}
          useWindow={true}
        >
          <List
            itemLayout="vertical"
            dataSource={this.props.commentList}
            renderItem={this.renderItem}
          >
            {this.props.hasMoreComments && (
              <div style={styles.loadingContainer}>
                <Spin />
              </div>
            )}
          </List>
        </InfiniteScroll>
      </div>
    );
  }
}

const styles = {
  loadingContainer: {
    bottom: 40,
    width: '100%',
  },
  infiniteContainer: {
    flex: 1,
    backgroundColor: 'white',
    border: '1px solid #e8e8e8',
    borderRadius: 4,
    overflow: 'auto',
    padding: '8 24',
  }
}


// WEBPACK FOOTER //
// ./src/modules/comment/list/CommentListView.tsx